import { render, staticRenderFns } from "./products-search-input.vue?vue&type=template&id=c0f37126"
import script from "./products-search-input.vue?vue&type=script&lang=js"
export * from "./products-search-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./products-search-input.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports